var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DividedList',{attrs:{"items":_vm.users,"empty-message":_vm.$t('no_users_existing'),"list-item":_vm.UserListItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }